export enum UserBanStatus {
    None,
    FirstTimeBan,
    Banned,
}
